import { mappingFunction } from "../../plugins/mappingBaseRef";
import powerpoint from "@/api/powerpoint";
import results from "@/api/results";
import journey from "./journey";

const state = {
  info: {},
  html: "",
  responseUrl: "",
  isLoadingEx: false,
  isLoadingPpt: false,
};

const mutations = {
  getAll(state, item) {
    state.info = item;
  },
  getHtml(state, text) {
    state.html = text;
  },
  getUrl(state, url) {
    state.responseUrl = url;
  },
  loadingTrueEx(state) {
    state.isLoadingEx = true;
  },
  loadingFalseEx(state) {
    state.isLoadingEx = false;
  },
  loadingTruePpt(state) {
    state.isLoadingPpt = true;
  },
  loadingFalsePpt(state) {
    state.isLoadingPpt = false;
  },
};

const actions = {
  exportAllInfo({ commit, state }, item) {
    commit("loadingTrueEx");
    const params = mappingFunction(item.base, item.ref);
    const saved = Object.assign({}, params, {
      journeyName: journey.state.name,
    });
    commit("getAll", saved);
    powerpoint.fullExport(saved).then((res) => {
      commit("getHtml", res.data);
      let blob = new Blob([state.html], { type: "application/vnd.ms-excel" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, journey.state.name + ".xls");
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = journey.state.name + ".xls";
        link.click();
      }
      commit("loadingFalseEx");
    });
  },
  exportAllInfoPowerpoint({ commit }, item) {
    commit("loadingTruePpt");
    const params = mappingFunction(item.base, item.ref);
    const saved = Object.assign({}, params, {
      journeyName: journey.state.name,
    });
    commit("getAll", saved);
    powerpoint.fullExportPowerpoint(saved).then((res) => {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, journey.state.name + ".pptx");
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = journey.state.name + ".pptx";
        link.click();
      }
      commit("loadingFalsePpt");
    });
  },
  exportAiCommunicationTest({ commit, state }, item) {
    const params = mappingFunction(item.base, item.ref);
    const saved = Object.assign({}, params, {
      journeyName: journey.state.name,
    });
    commit("getAll", saved);
    return saved;
  },
  exportCatInfo({ commit, state }, data) {
    data.item, data.pageName;
    commit("loadingTrueEx");
    const params = mappingFunction(data.item.base, data.item.ref);
    const saved = Object.assign({}, params, {
      journeyName: journey.state.name,
      getExcelDataTable: true,
    });
    commit("getAll", saved);
    switch (data.pageName) {
      case "archetypen":
        results.resultsArchetypesExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "merken":
        results.resultsBrandsExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "duurzaamheid":
        results.resultsSustainabilityExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "lifestyle":
        results.resultsLifestyleExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "media":
        results.resultsMediaExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "overtuigingsstrategieën":
        results.resultsPersuasionExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "politiek":
        results.resultsPoliticsExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "demografie":
        results.resultsDemographicsExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "onderstromen":
        results.resultsUndercurrentExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "waardekaarten":
        results.resultsValuesCardsExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
      case "mentality":
        results.resultsMentalityExcel(saved).then((res) => {
          commit("getHtml", res.data);
          let blob = new Blob([state.html], {
            type: "application/vnd.ms-excel",
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              journey.state.name + ".xls"
            );
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = journey.state.name + ".xls";
            link.click();
          }
          commit("loadingFalseEx");
        });
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
